import Reflux from 'reflux';

import actions from '../actions';
import configurationStore from './configuration-store';
import stateStore from './accessory-state-store';

export default Reflux.createStore({
	listenables: actions,

	init() {
		this.listenTo(stateStore, this.onStateChange);
		this.state = {
			items: {}
		};
	},

	_mapItem(item) {
		// map item properties with facet id for easy access
		let mappedProperties = {};
		item.properties
			.forEach((property) => {
				if (property) mappedProperties[property.facet.id] = property;
			});
		item.properties = mappedProperties;
	},

	_mapItems(items) {
		// map items  with thier number for easy access
		items
			.filter(item => item)
			.map(item => this._mapItem(item));

		let mappedItems = {};
		items
			.forEach((item) => {
				if (item) mappedItems[item.number] = item;
			});
		return mappedItems;
	},

	onStateChange(state) {
		this.state.items = {};
		this.output();
	},

	onLoadItemsCompleted(data) {
		this.state.items = this._mapItems(data.body);
		this.output();
	},

	onLoadItemCompleted(data) {
		this.output();
	},


	getState() {
		return this.state;
	},

	output() {
		this.trigger(this.getState());
	},

	getInitialState() {
		return this.getState();
	}
});
